var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 574,
    height: 499,
    viewBox: "0 0 574 499",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.3722 259.663C94.3222 299.335 125.839 331.3 165.253 349.809C204.667 368.319 249.392 372.157 291.384 360.634C333.375 349.111 369.878 322.983 394.325 286.95C418.772 250.916 429.56 207.342 424.747 164.065M151.965 225.46C161.771 247.134 178.989 264.597 200.521 274.708C222.053 284.82 246.487 286.917 269.428 280.622C292.368 274.327 312.309 260.053 325.665 240.368C339.021 220.682 344.914 196.877 342.285 173.235",
    stroke: "#FFCC04",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.57 88.9867L322.466 158.191C317.383 165.822 323.528 175.914 332.641 174.901L438.923 163.083C448.035 162.069 451.813 150.874 445.178 144.547L384.999 87.1599C380.145 82.531 372.288 83.4046 368.57 88.9867Z",
    fill: "#1B9B48",
    stroke: "#FFCC04",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg2);
export default __webpack_public_path__ + "static/media/bg-2.576e331088bbbe632b5579aaaa0bad63.svg";
export { ForwardRef as ReactComponent };